/**
 * @enum LanguageType
 * @description All supported Language type will be declared here
 */
enum LanguageType {
  ENGLISH = "ENGLISH",
  GERMAN = "GERMAN"
}

export default LanguageType;
